"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = isArray;
exports.isBoolean = isBoolean;
exports.isPlainObject = isPlainObject;
exports.isString = isString;

function isArray(ref) {
  return Array.isArray(ref);
}

function isBoolean(ref) {
  return ref === true || ref === false;
}

function isPlainObject(ref) {
  return typeof ref === 'object' && ref.constructor === Object;
}

function isString(ref) {
  return typeof ref === 'string' || ref instanceof String;
}